import 'react-router-modal/css/react-router-modal.css';

import * as PropTypes from 'prop-types';

import { inject, observer } from 'mobx-react';

import { BrowserRouter } from 'react-router-dom';
import { DaangnPath } from './util/PathType';
import React from 'react';
import Router from './Router';
import ScrollToTop from './util/ScrollToTop';
import moment from 'moment';

function RootRouter() {
  // var startTime = moment('20220111 01:00 am', 'YYYYMMDD HH:mm a');
  // var endTime = moment('20220111 04:00 am', 'YYYYMMDD HH:mm a');
  // if (moment().isBetween(startTime, endTime)) {
  //   return <Waitforinspect />;
  // }
  return (
    <BrowserRouter>
      <ScrollToTop>
        <>
          <DaangnPath>
            <Router />
          </DaangnPath>
        </>
      </ScrollToTop>
    </BrowserRouter>
  );
}

export default observer(RootRouter);
